import { Component, OnInit } from '@angular/core';
import { SaleService } from 'src/app/services/partner/sale.service';
import { Router } from '@angular/router';
import { MainService } from 'src/app/services/delavci/main.service';

@Component({
  selector: 'app-sale-select',
  templateUrl: './sale-select.component.html',
  styleUrls: ['./sale-select.component.css']
})
export class SaleSelectComponent implements OnInit {

  constructor(private saleService: SaleService, private router: Router, private mainService: MainService) { }

  ngOnInit() {
    this.mainService.changeHref(this.router.url);

  }

  saleTypeSkupine(type) {
    this.saleService.changeSaleType('SALE_DATE_IGRO_01');
    this.router.navigate(['/prodaja/izbira/' + type]);
  }

  saleTypeUre(type) {
    this.saleService.changeSaleType('SALE_HOUR_01');
    this.router.navigate(['/prodaja/izbira/' + type]);
  }

  saleTypeSkladisce(type) {
    this.saleService.changeSaleType('SALE_DATE_PART_01');
    this.router.navigate(['/prodaja/izbira/' + type]);
  }
}
